var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNbl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0701 31.6557C20.0701 31.6557 20.0701 29.11 23.1249 28.4736L36.0634 24.9096C36.0634 24.9096 37.7117 24.4259 38.2781 23.2422C38.2781 23.2422 38.2399 31.4139 38.2781 31.4075C37.9599 34.3669 34.6378 35.0033 34.6378 35.0033L20.0701 39V31.6557Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0701 20.862C20.0701 20.862 20.0701 18.3163 23.1249 17.6799L36.0634 14.1223C36.0634 14.1223 37.7117 13.6386 38.2781 12.4421C38.2781 12.4421 38.2399 20.6265 38.2781 20.6138C37.9663 23.6114 34.6442 24.2478 34.6442 24.2478L20.0701 28.2127V20.862Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7144 33.9596V31.6557C18.7144 31.6557 18.7144 29.11 15.6596 28.4736L2.71475 24.9096C2.71475 24.9096 1.07278 24.4132 0.5 23.2295C0.5 23.2295 0.550914 31.4012 0.5 31.3948C0.824576 34.3669 4.1467 35.0033 4.1467 35.0033L18.7144 38.981V33.9596Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7144 20.862C18.7144 20.862 18.7144 18.3164 15.6596 17.6799L2.71475 14.1223C2.71475 14.1223 1.07278 13.6259 0.5 12.4294C0.5 12.4294 0.550914 20.6138 0.5 20.6011C0.811847 23.5987 4.13398 24.2351 4.13398 24.2351L18.7017 28.2127L18.7144 20.862Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3652 17.018V12.983C17.3874 12.3604 17.2027 11.7479 16.8401 11.2412C16.4774 10.7346 15.9571 10.3624 15.3604 10.1828L3.2684 6.6188V12.9258C2.8721 12.8599 2.49531 12.7071 2.16517 12.4782C1.83503 12.2493 1.55974 11.95 1.35913 11.602V0L16.1814 3.87582C19.4017 4.95137 19.2044 7.54161 19.2044 7.54161V18.4881C18.8019 17.7809 18.1437 17.2548 17.3652 17.018Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbl);
export default __webpack_public_path__ + "static/media/nbl.1eb515c1f3ec29faa08485b91487f9bb.svg";
export { ForwardRef as ReactComponent };